import TemplateCardContent, { TemplateCardContentProps } from './TemplateCardContent';

export type { TemplateCardContentProps };
export default TemplateCardContent;
